import { render, staticRenderFns } from "./project-detail-base.vue?vue&type=template&id=17495ba1&scoped=true&"
import script from "./project-detail-base.vue?vue&type=script&lang=js&"
export * from "./project-detail-base.vue?vue&type=script&lang=js&"
import style0 from "./project-detail-base.vue?vue&type=style&index=0&id=17495ba1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17495ba1",
  null
  
)

export default component.exports